import { UserHasScopes, UserIsLoggedIn, UserIsNotLoggedIn } from './views/middleware/Route/Auth';
import VueRouter, { RouteConfig } from 'vue-router';

import { Roles } from '@/services/Roles';
import Vue from 'vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/login',
    component: () => import('./views/pages/Index.vue'),
    beforeEnter: UserIsNotLoggedIn,
    children: [
      {
        name: 'auth_login',
        path: '',
        component: () => import('./views/pages/Login.vue'),
      },
    ],
  },
  {
    path: '/ssl',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'certificate_all',
        path: '',
        component: () => import('./views/pages/ssl/AllCertificates.vue'),
        beforeEnter: UserHasScopes([Roles.SSL_CERT_READ]),
        meta: {
          title: 'Certificates',
        },
      },
      {
        name: 'certificate_create',
        path: 'create',
        component: () => import('./views/pages/ssl/CreateCertificate.vue'),
        beforeEnter: UserHasScopes([Roles.SSL_CERT_CREATE]),
        meta: {
          title: 'New Certificate',
        },
      },
    ],
  },
  {
    path: '/users',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'users_index',
        path: '',
        component: () => import('./views/pages/users/AllUsers.vue'),
        beforeEnter: UserHasScopes([Roles.USER_USERS_READ]),
        meta: {
          title: 'Users',
        },
      },
      {
        name: 'user_create',
        path: 'create',
        component: () => import('./views/pages/users/CreateUser.vue'),
        beforeEnter: UserHasScopes([Roles.USER_USERS_CREATE]),
        meta: {
          title: 'Create New User',
        },
      },
      {
        name: 'user_edit',
        path: 'edit/:userId',
        component: () => import('./views/pages/users/EditUser.vue'),
        beforeEnter: UserHasScopes([Roles.USER_USERS_EDIT]),
        meta: {
          title: 'Edit User',
        },
      },
    ],
  },
  {
    path: '/roles',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'role_index',
        path: '',
        component: () => import('./views/pages/roles/AllRoles.vue'),
        beforeEnter: UserHasScopes([Roles.USER_ROLES_READ]),
        meta: {
          title: 'Roles',
        },
      },
      {
        name: 'role_create',
        path: 'create',
        component: () => import('./views/pages/roles/CreateRole.vue'),
        beforeEnter: UserHasScopes([Roles.USER_ROLES_CREATE]),
        meta: {
          title: 'Create New Role',
        },
      },
      {
        name: 'role_edit',
        path: 'edit/:roleId',
        component: () => import('./views/pages/roles/EditRole.vue'),
        beforeEnter: UserHasScopes([Roles.USER_ROLES_UPDATE]),
        meta: {
          title: 'Edit Role',
        },
      },
    ],
  },
  {
    path: '/departments',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'department_index',
        path: '',
        component: () => import('./views/pages/departments/AllDepartments.vue'),
        beforeEnter: UserHasScopes([Roles.USER_DEPARTMENTS_READ]),
        meta: {
          title: 'Departments',
        },
      },
      {
        name: 'department_create',
        path: 'create',
        component: () => import('./views/pages/departments/CreateDepartment.vue'),
        beforeEnter: UserHasScopes([Roles.USER_DEPARTMENTS_CREATE]),
        meta: {
          title: 'Create New Department',
        },
      },
      {
        name: 'department_edit',
        path: 'edit/:departmentId',
        component: () => import('./views/pages/departments/EditDepartment.vue'),
        beforeEnter: UserHasScopes([Roles.USER_DEPARTMENTS_UPDATE]),
        meta: {
          title: 'Edit Department',
        },
      },
    ],
  },
  {
    path: '/server',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'server_all',
        path: '/',
        component: () => import('./views/pages/server/AllServers.vue'),
        beforeEnter: UserHasScopes([Roles.SERVER_SERVER_READ]),
        meta: {
          title: 'Servers',
        },
      },
      {
        name: 'server_add',
        path: 'create',
        component: () => import('./views/pages/server/AddServer.vue'),
        beforeEnter: UserHasScopes([Roles.SERVER_SERVER_READ]),
        meta: {
          title: 'Add Server',
        },
      },
      {
        name: 'server_view',
        path: '/server/:server',
        component: () => import('./views/pages/server/ViewServer.vue'),
        beforeEnter: UserHasScopes([Roles.SERVER_SERVER_READ]),
        meta: {
          title: 'Server',
        },
      },
      {
        name: 'server_edit',
        path: '/edit/:server',
        component: () => import('./views/pages/server/EditServer.vue'),
        beforeEnter: UserHasScopes([Roles.USER_DEPARTMENTS_UPDATE]),
        meta: {
          title: 'Edit Server',
        },
      },
    ],
  },
  {
    path: '/sms',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'template_add',
        path: 'templates/create',
        component: () => import('./views/pages/sms/AddTemplate.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_CREATE]),
        meta: {
          title: 'Create Template',
        },
      },
      {
        name: 'sms_add',
        path: 'messages/create',
        component: () => import('./views/pages/sms/AddSms.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_CREATE]),
        meta: {
          title: 'Send Message',
        },
      },
      {
        name: 'sms_list',
        path: 'messages',
        component: () => import('./views/pages/sms/SmsList.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Sms List',
        },
      },
      {
        name: 'template_list',
        path: 'templates',
        component: () => import('./views/pages/sms/TemplateList.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Template List',
        },
      },
    ],
  },
  {
    path: '/ipset',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'ipset_lists',
        path: 'sets',
        component: () => import('./views/pages/ipset/AllIPSetLists.vue'),
        beforeEnter: UserHasScopes([Roles.IPSET_IPSET_READ]),
        meta: {
          title: 'IPSet Lists',
        },
      },
      {
        name: 'ipset_list_create',
        path: 'sets/create',
        component: () => import('./views/pages/ipset/CreateIPSetList.vue'),
        beforeEnter: UserHasScopes([Roles.IPSET_IPSET_READ]),
        meta: {
          title: 'New IPSet List',
        },
      },
      {
        name: 'ipset_list_view',
        path: 'sets/:setName',
        component: () => import('./views/pages/ipset/ViewIPSetList.vue'),
        beforeEnter: UserHasScopes([Roles.IPSET_IPSET_READ]),
        meta: {
          title: 'IPSet List',
        },
      },
    ],
  },
  {
    path: '/vhost',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'cdn_vhost_list',
        path: 'cdn',
        component: () => import('./views/pages/vhost/cdn/AllVHosts.vue'),
        beforeEnter: UserHasScopes([Roles.VHOST_VHOST_READ]),
        meta: { title: 'CDN VHosts List' },
      },
      {
        name: 'cdn_vhost_create',
        path: 'cdn/create',
        component: () => import('./views/pages/vhost/cdn/CreateVHost.vue'),
        beforeEnter: UserHasScopes([Roles.VHOST_VHOST_CREATE]),
        meta: { title: 'CDN VHosts Create' },
      },
      {
        name: 'origin_vhost_list',
        path: 'origin',
        component: () => import('./views/pages/vhost/origin/AllVHosts.vue'),
        beforeEnter: UserHasScopes([Roles.VHOST_VHOST_READ]),
        meta: { title: 'Origin VHosts List' },
      },
      {
        name: 'origin_vhost_create',
        path: 'origin/create',
        component: () => import('./views/pages/vhost/origin/CreateVHost.vue'),
        beforeEnter: UserHasScopes([Roles.VHOST_VHOST_READ]),
        meta: { title: 'Origin VHosts Create' },
      },
    ],
  },
  {
    path: '/websites',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'website_groups',
        path: 'groups',
        component: () => import('./views/pages/website/AllWebsiteGroups.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_READ]),
        meta: {
          title: 'Website groups',
        },
      },
      {
        name: 'website_group_view',
        path: 'groups/:id',
        component: () => import('./views/pages/website/ViewWebsiteGroup.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_READ]),
      },
      {
        name: 'website_all',
        path: '/',
        component: () => import('./views/pages/website/AllWebsites.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_READ]),
        meta: {
          title: 'Websites',
        },
      },
      {
        name: 'website_create',
        path: 'create',
        component: () => import('./views/pages/website/CreateWebsite.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_CREATE]),
        meta: {
          title: 'Create Website',
        },
      },
      {
        name: 'website_view',
        path: ':id',
        component: () => import('./views/pages/website/ViewWebsite.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_READ]),
        meta: {
          title: 'Websites',
        },
      },
    ],
  },
  {
    path: '/dns',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'dns_zones',
        path: '/',
        component: () => import('./views/pages/dns/AllDns.vue'),
        beforeEnter: UserHasScopes([Roles.DNS_ZONE_READ]),
        meta: {
          title: 'DNS Zones',
        },
      },
      {
        name: 'dns_zone_create',
        path: 'zone/create',
        component: () => import('./views/pages/dns/CreateDns.vue'),
        beforeEnter: UserHasScopes([Roles.DNS_ZONE_CREATE]),
        meta: {
          title: 'New DNS Zone',
        },
      },
      {
        name: 'dns_zone_view',
        path: 'zone/:id',
        component: () => import('./views/pages/dns/ViewDns.vue'),
        beforeEnter: UserHasScopes([Roles.DNS_ZONE_READ]),
        meta: {
          title: 'DNS Zone',
        },
      },
      {
        name: 'dns_record_create',
        path: 'zone/:id/create',
        component: () => import('./views/pages/dns/CreateDnsRecord.vue'),
        beforeEnter: UserHasScopes([Roles.DNS_ZONE_CREATE]),
        meta: {
          title: 'New DNS Record',
        },
      },
      {
        name: 'dns_departments',
        path: 'departments',
        component: () => import('./views/pages/dns/DNSDepartments.vue'),
        beforeEnter: UserHasScopes([Roles.DNS_DEPARTMENT]),
        meta: {
          title: 'DNS Departments',
        },
      },
    ],
  },
  {
    path: '/qc',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'chat_list',
        path: 'chats',
        component: () => import('./views/pages/qa/chat/AllChats.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_READ]),
        meta: { title: 'Chat List' },
      },
      {
        name: 'escalation_list',
        path: 'escalations',
        component: () => import('./views/pages/qa/escalation/AllEscalations.vue'),
        beforeEnter: UserHasScopes([Roles.QA_ESCALATION_READ]),
        meta: { title: 'Escalation List' },
      },
      {
        name: 'feedback_list',
        path: 'feedbacks',
        component: () => import('./views/pages/qa/feedback/AllFeedbacks.vue'),
        beforeEnter: UserHasScopes([Roles.QA_FEEDBACK_READ]),
        meta: { title: 'Feedback List' },
      },
      {
        name: 'feedback_view',
        path: 'feedbacks/:feedbackId',
        component: () => import('./views/pages/qa/feedback/ViewFeedback.vue'),
        beforeEnter: UserHasScopes([Roles.QA_FEEDBACK_READ]),
        meta: { title: 'Feedback View' },
      },
      {
        name: 'escalation_view',
        path: 'escalations/:escalationId',
        component: () => import('./views/pages/qa/escalation/ViewEscalation.vue'),
        beforeEnter: UserHasScopes([Roles.QA_ESCALATION_READ]),
        meta: { title: 'Escalation View' },
      },
      {
        name: 'chats_queue',
        path: 'chats/queue',
        component: () => import('./views/pages/qa/chat/ChatsQueue.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_READ]),
        meta: { title: 'Chat Queue List' },
      },
      {
        name: 'chat_review',
        path: 'chats/review',
        component: () => import('./views/pages/qa/chat/ReviewChat.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_REVIEW]),
        meta: { title: 'Review Chat' },
      },
      {
        name: 'chat_view',
        path: 'chats/:chatId',
        component: () => import('./views/pages/qa/chat/ViewChat.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_READ]),
        meta: { title: 'View Chat' },
      },
      {
        name: 'ticket_list',
        path: 'tickets',
        component: () => import('./views/pages/qa/ticket/AllTickets.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TICKET_READ]),
        meta: { title: 'Ticket List' },
      },
      {
        name: 'ticket_review',
        path: 'tickets/review/:ticketId',
        component: () => import('./views/pages/qa/ticket/ReviewTicket.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TICKET_REVIEW]),
        meta: { title: 'Ticket Review' },
      },
      {
        name: 'ticket_view',
        path: 'tickets/:ticketId',
        component: () => import('./views/pages/qa/ticket/ViewTicket.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TICKET_READ]),
        meta: { title: 'Ticket View' },
      },
      {
        name: 'qc_statistics',
        path: 'statistics',
        component: () => import('./views/pages/qa/statistics/MainStatistic.vue'),
        beforeEnter: UserHasScopes([Roles.QA_STATISTICS_READ]),
        meta: { title: 'QA Statistics' },
      },
      {
        name: 'all_dossiers',
        path: 'dossiers',
        component: () => import('./views/pages/qa/dossier/AllDossiers.vue'),
        beforeEnter: UserHasScopes([Roles.QA_DOSSIER_COMMENT_CREATE, Roles.QA_DOSSIER_COMMENT_READ]),
        meta: { title: 'Dossiers' },
      },
      {
        name: 'dossiers',
        path: 'dossiers/:userId',
        component: () => import('./views/pages/qa/dossier/Dossier.vue'),
        beforeEnter: UserHasScopes([Roles.QA_DOSSIER_COMMENT_CREATE, Roles.QA_DOSSIER_COMMENT_READ]),
        meta: { title: 'Dossier' },
      },
    ],
  },
  {
    path: '/qc-settings',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'tag_list',
        path: 'tags',
        component: () => import('./views/pages/qa/tag/AllTags.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TAG_READ]),
        meta: { title: 'Tag List' },
      },
      {
        name: 'tag_create',
        path: 'tags/create',
        component: () => import('./views/pages/qa/tag/CreateTag.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TAG_CREATE]),
        meta: { title: 'Tag Create' },
      },
      {
        name: 'tag_update',
        path: 'tags/update/:tagId',
        component: () => import('./views/pages/qa/tag/EditTag.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TAG_UPDATE]),
        meta: { title: 'Tag Edit' },
      },
      {
        name: 'score_type_list',
        path: 'score/types',
        component: () => import('./views/pages/qa/scoreType/AllScoreTypes.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_TYPE_READ]),
        meta: { title: 'Score Type List' },
      },
      {
        name: 'score_type_create',
        path: 'score/types/create',
        component: () => import('./views/pages/qa/scoreType/CreateScoreType.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_TYPE_CREATE]),
        meta: { title: 'Score Type Create' },
      },
      {
        name: 'score_type_update',
        path: 'score/types/update/:scoreTypeId',
        component: () => import('./views/pages/qa/scoreType/EditScoreType.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_TYPE_UPDATE]),
        meta: { title: 'Score Type Update' },
      },
      {
        name: 'score_grade_list',
        path: 'score/grades',
        component: () => import('./views/pages/qa/scoreGrade/AllScoreGrades.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_GRADE_READ]),
        meta: { title: 'Score Grade List' },
      },
      {
        name: 'score_grade_create',
        path: 'score/grades/create',
        component: () => import('./views/pages/qa/scoreGrade/CreateScoreGrade.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_GRADE_CREATE]),
        meta: { title: 'Score Grade Create' },
      },
      {
        name: 'score_grade_update',
        path: 'score/grades/update/:scoreGradeId',
        component: () => import('./views/pages/qa/scoreGrade/EditScoreGrade.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_GRADE_UPDATE]),
        meta: { title: 'Score Grade Update' },
      },
      {
        name: 'all_cron_settings',
        path: 'cron',
        component: () => import('./views/pages/qa/cron-settings/AllSettings.vue'),
        beforeEnter: UserHasScopes([Roles.QA_MANAGER]),
        meta: { title: 'Cron Settings' },
      },
      {
        name: 'create_cron_settings',
        path: 'cron/create',
        component: () => import('./views/pages/qa/cron-settings/CreateSettings.vue'),
        beforeEnter: UserHasScopes([Roles.QA_MANAGER]),
        meta: { title: 'Create Cron Settings' },
      },
      {
        name: 'edit_cron_settings',
        path: 'cron/edit/:id',
        component: () => import('./views/pages/qa/cron-settings/EditSettings.vue'),
        beforeEnter: UserHasScopes([Roles.QA_MANAGER]),
        meta: { title: 'Edit Cron Settings' },
      },
      {
        name: 'chat_queue_settings',
        path: 'chats/queue',
        component: () => import('./views/pages/qa/chat-queue-settings/ChatQueueSettings.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_QUEUE_SETTINGS]),
        meta: { title: 'Chat Queue Settings' },
      },
    ],
  },
  {
    path: '/qc-v2',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'chat_archive',
        path: 'chats/archive/:chatId?',
        component: () => import('./views/pages/qc-v2/chat/Archive.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_REVIEW]),
        meta: { title: 'Chat Archive' },
      },
      {
        name: 'chat_queue',
        path: 'chats/queue/:chatId?',
        component: () => import('./views/pages/qc-v2/chat/Queue.vue'),
        beforeEnter: UserHasScopes([Roles.QA_CHAT_REVIEW]),
        meta: { title: 'Chat Queue' },
      },
      {
        name: 'tickets_archive',
        path: 'tickets/archive',
        component: () => import('./views/pages/qc-v2/ticket/Archive.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TICKET_REVIEW]),
        meta: { title: 'Ticket Archive' },
      },
      {
        name: 'tickets_queue',
        path: 'tickets/queue',
        component: () => import('./views/pages/qc-v2/ticket/Queue.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TICKET_REVIEW]),
        meta: { title: 'Ticket Queue' },
      },
      {
        name: 'ticket',
        path: 'tickets/:ticketId',
        component: () => import('./views/pages/qc-v2/ticket/Ticket.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TICKET_REVIEW]),
        meta: { title: 'Ticket' },
      },
      {
        name: 'feedbacks',
        path: 'feedbacks',
        component: () => import('./views/pages/qc-v2/feedback/AllFeedbacks.vue'),
        beforeEnter: UserHasScopes([Roles.QA_FEEDBACK_READ]),
        meta: { title: 'Feedbacks' },
      },
      {
        name: 'chat_feedback',
        path: 'chat-feedbacks/:id',
        component: () => import('./views/pages/qc-v2/feedback/ChatFeedback.vue'),
        beforeEnter: UserHasScopes([Roles.QA_FEEDBACK_READ]),
        meta: { title: 'Chat Feedback' },
      },
      {
        name: 'ticket_feedback',
        path: 'ticket-feedbacks/:id',
        component: () => import('./views/pages/qc-v2/feedback/TicketFeedback.vue'),
        beforeEnter: UserHasScopes([Roles.QA_FEEDBACK_READ]),
        meta: { title: 'Ticket Feedback' },
      },
      {
        name: 'escalations',
        path: 'escalations',
        component: () => import('./views/pages/qc-v2/escalation/AllEscalations.vue'),
        beforeEnter: UserHasScopes([Roles.QA_ESCALATION_READ]),
        meta: { title: 'Escalations' },
      },
      {
        name: 'chat_escalation',
        path: 'chat-escalations/:id',
        component: () => import('./views/pages/qc-v2/escalation/ChatEscalation.vue'),
        beforeEnter: UserHasScopes([Roles.QA_ESCALATION_READ]),
        meta: { title: 'Chat Escalation' },
      },
      {
        name: 'ticket_escalation',
        path: 'ticket-escalations/:id',
        component: () => import('./views/pages/qc-v2/escalation/TicketEscalation.vue'),
        beforeEnter: UserHasScopes([Roles.QA_ESCALATION_READ]),
        meta: { title: 'Chat Escalation' },
      },
      {
        name: 'statistics',
        path: 'statistics',
        component: () => import('./views/pages/qc-v2/statistic/Statistics.vue'),
        beforeEnter: UserHasScopes([Roles.QA_STATISTICS_READ]),
        meta: { title: 'Statistics' },
      },
      {
        name: 'user-statistics',
        path: 'statistics/users/:userId',
        component: () => import('./views/pages/qc-v2/statistic/UserStatistics.vue'),
        beforeEnter: UserHasScopes([Roles.QA_STATISTICS_READ]),
        meta: { title: 'User Statistics' },
      },
    ],
  },
  {
    path: '/qc-settings-v2',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'scores',
        path: 'scores',
        component: () => import('./views/pages/qc-v2/scores/Scores.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_TYPE_READ, Roles.QA_SCORE_GRADE_READ]),
        meta: { title: 'Score Types' },
      },
      {
        name: 'create_score_type',
        path: 'scores/types',
        component: () => import('./views/pages/qc-v2/scores/CreateScoreType.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_TYPE_CREATE]),
        meta: { title: 'Create Score Type' },
      },
      {
        name: 'update_score_type',
        path: 'scores/types/:scoreTypeId',
        component: () => import('./views/pages/qc-v2/scores/EditScoreType.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_TYPE_UPDATE]),
        meta: { title: 'Edit Score Type' },
      },

      {
        name: 'create_score_grade',
        path: 'scores/grades',
        component: () => import('./views/pages/qc-v2/scores/CreateScoreGrade.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_GRADE_CREATE]),
        meta: { title: 'Create Score Grade' },
      },
      {
        name: 'update_score_grade',
        path: 'scores/types/:scoreGradeId',
        component: () => import('./views/pages/qc-v2/scores/EditScoreGrade.vue'),
        beforeEnter: UserHasScopes([Roles.QA_SCORE_GRADE_UPDATE]),
        meta: { title: 'Edit Score Grade' },
      },
      {
        name: 'tags',
        path: 'tags',
        component: () => import('./views/pages/qc-v2/tags/Tags.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TAG_READ]),
        meta: { title: 'Tags' },
      },
      {
        name: 'create_tag',
        path: 'tags/create',
        component: () => import('./views/pages/qc-v2/tags/CreateTag.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TAG_CREATE]),
        meta: { title: 'Create Tag' },
      },
      {
        name: 'update_tag',
        path: 'tags/:tagId',
        component: () => import('./views/pages/qc-v2/tags/EditTag.vue'),
        beforeEnter: UserHasScopes([Roles.QA_TAG_UPDATE]),
        meta: { title: 'Update Tag' },
      },
      {
        name: 'ticket_cron_config',
        path: 'ticket-cron-config',
        component: () => import('./views/pages/qc-v2/ticket/CronConfig.vue'),
        beforeEnter: UserHasScopes([Roles.QA_MANAGER]),
        meta: { title: 'Ticket Cron Config' },
      },
      {
        name: 'create_ticket_cron_config',
        path: 'ticket-cron-config/create',
        component: () => import('./views/pages/qc-v2/ticket/CreateTicketCronConfig.vue'),
        beforeEnter: UserHasScopes([Roles.QA_MANAGER]),
        meta: { title: 'Ticket Cron Config' },
      },
      {
        name: 'update_ticket_cron_config',
        path: 'ticket-cron-config/:id',
        component: () => import('./views/pages/qc-v2/ticket/UpdateTicketCronConfig.vue'),
        beforeEnter: UserHasScopes([Roles.QA_MANAGER]),
        meta: { title: 'Ticket Cron Config Update' },
      },
    ],
  },
  {
    path: '/dossiers',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'all-agents',
        path: '/dossiers',
        component: () => import('./views/pages/dossier/AllAgents.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_USER_READ]),
        meta: { title: 'All Agents' },
      },
      {
        name: 'add-agent',
        path: 'add',
        component: () => import('./views/pages/dossier/AddAgent.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_USER_CREATE]),
        meta: { title: 'Add Agent' },
      },
      {
        name: 'update-agent',
        path: ':userId/update',
        component: () => import('./views/pages/dossier/UpdateAgent.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_USER_UPDATE]),
        meta: { title: 'Update Agent' },
      },
      {
        name: 'all-teams',
        path: 'teams',
        component: () => import('./views/pages/dossier/AllTeams.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_USER_CREATE]),
        meta: { title: 'All Teams' },
      },
      {
        name: 'create-team',
        path: 'teams/create',
        component: () => import('./views/pages/dossier/CreateTeam.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_USER_CREATE]),
        meta: { title: 'Create Team' },
      },
      {
        name: 'agent-profile',
        path: '/dossiers/:userId',
        component: () => import('./views/pages/dossier/AgentDossier.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_USER_READ]),
        meta: { title: 'Agent Profile' },
      },
      {
        name: 'create-agent-feedback',
        path: '/dossiers/:userId/feedbacks/create',
        component: () => import('./views/pages/dossier/CreateAgentFeedback.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_FEEDBACK_CREATE]),
        meta: { title: 'Create Feedback' },
      },
      {
        name: 'view-feedback',
        path: '/dossiers/:userId/feedbacks/:feedbackId',
        component: () => import('./views/pages/dossier/ViewFeedback.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_FEEDBACK_READ]),
        meta: { title: 'View Feedback' },
      },
      {
        name: 'update-feedback',
        path: '/dossiers/:userId/feedbacks/:feedbackId/update',
        component: () => import('./views/pages/dossier/UpdateAgentFeedback.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_FEEDBACK_UPDATE]),
        meta: { title: 'Update Feedback' },
      },
      {
        name: 'review-categories',
        path: '/review-categories',
        component: () => import('./views/pages/dossier/ReviewCategories.vue'),
        beforeEnter: UserHasScopes([Roles.DOSSIER_FEEDBACK_READ]),
        meta: { title: 'Review Categories' },
      },
    ],
  },
  {
    path: '/calendar',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'calendar_shifts',
        path: 'shifts',
        component: () => import('./views/pages/calendar/shifts/Shifts.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_READ]),
        meta: { title: 'Shifts' },
      },
      {
        name: 'calendar_manage_shifts',
        path: 'shifts/manage',
        component: () => import('./views/pages/calendar/shifts/Manage.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Manage Shifts' },
      },
      {
        name: 'calendar_crate_shift_type',
        path: 'shifts/type',
        component: () => import('./views/pages/calendar/shifts/CreateShiftType.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Create Shift Type' },
      },
      {
        name: 'calendar_edit_shift_type',
        path: 'shifts/type/:shiftTypeId',
        component: () => import('./views/pages/calendar/shifts/EditShiftType.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Edit Shift Type' },
      },
      {
        name: 'calendar_crate_shift_automation',
        path: 'shifts/automation',
        component: () => import('./views/pages/calendar/shifts/CreateShiftAutomation.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Create Shift Automation' },
      },
      {
        name: 'calendar_edit_shift_automation',
        path: 'shifts/automation/:id',
        component: () => import('./views/pages/calendar/shifts/EditShiftAutomation.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Edit Shift Automation' },
      },
      {
        name: 'calendar_events',
        path: 'events',
        component: () => import('./views/pages/calendar/events/Events.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_READ]),
        meta: { title: 'Events' },
      },
      {
        name: 'calendar_manage_events',
        path: 'events/manage',
        component: () => import('./views/pages/calendar/events/Manage.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Manage Events' },
      },
      {
        name: 'calendar_crate_event',
        path: 'events/event',
        component: () => import('./views/pages/calendar/events/CreateEvent.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Create Event' },
      },
      {
        name: 'calendar_edit_event',
        path: 'events/event/:eventId',
        component: () => import('./views/pages/calendar/events/EditEvent.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Edit Event' },
      },
      {
        name: 'calendar_crate_recurring_event',
        path: 'events/national-event',
        component: () => import('./views/pages/calendar/events/CreateNationalEvent.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Create National Event' },
      },
      {
        name: 'calendar_edit_recurring_event',
        path: 'events/national-event/:eventId',
        component: () => import('./views/pages/calendar/events/EditNationalEvent.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Edit National Event' },
      },
      {
        name: 'calendar_crate_repeatable_event',
        path: 'events/repeatable-event',
        component: () => import('./views/pages/calendar/events/CreateRepeatableEvent.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Create Repeatable Event' },
      },
      {
        name: 'calendar_edit_repeatable_event',
        path: 'events/repeatable-event/:eventId',
        component: () => import('./views/pages/calendar/events/EditRepeatableEvent.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Edit Repeatable Event' },
      },
      {
        name: 'calendar_event_attendant',
        path: 'events/event/:eventId/attendant',
        component: () => import('./views/pages/calendar/events/Attendant.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Event Attendants' },
      },
      {
        name: 'calendar_event_singup',
        path: 'events/event/:eventId/singup',
        component: () => import('./views/pages/calendar/events/EventSingup.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_SHIFTS_CREATE]),
        meta: { title: 'Event SingUp' },
      },
    ],
  },
  {
    name: 'databases',
    path: '/databases',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'database_list',
        path: 'list',
        component: () => import('./views/pages/database/AllDatabases.vue'),
        beforeEnter: UserHasScopes([Roles.DATABASE_DATABASE_READ]),
        meta: { title: 'List Databases' },
      },
      {
        name: 'database_create',
        path: 'create',
        component: () => import('./views/pages/database/CreateDatabase.vue'),
        beforeEnter: UserHasScopes([Roles.DATABASE_DATABASE_CREATE]),
        meta: { title: 'Database Create' },
      },
      {
        name: 'database_users_list',
        path: 'users/list',
        component: () => import('./views/pages/database/AllUsers.vue'),
        beforeEnter: UserHasScopes([Roles.DATABASE_DATABASE_CREATE]),
        meta: { title: 'List Database Users' },
      },
      {
        name: 'database_user_create',
        path: 'users/create',
        component: () => import('./views/pages/database/CreateUser.vue'),
        beforeEnter: UserHasScopes([Roles.DATABASE_USER_CREATE]),
        meta: { title: 'Database User Create' },
      },
      {
        name: 'database_user_edit',
        path: 'users/edit/:userId',
        component: () => import('./views/pages/database/EditUser.vue'),
        beforeEnter: UserHasScopes([Roles.DATABASE_USER_UPDATE]),
        meta: { title: 'Database User Edit' },
      },
    ],
  },
  {
    name: 'system_users',
    path: '/system-users',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'system_users_list',
        path: 'list',
        component: () => import('./views/pages/system-users/AllSystemUsers.vue'),
        beforeEnter: UserHasScopes([Roles.SYSTEM_USER_READ]),
        meta: { title: 'List System Users' },
      },
      {
        name: 'system_user_create',
        path: 'create',
        component: () => import('./views/pages/system-users/CreateSystemUser.vue'),
        beforeEnter: UserHasScopes([Roles.SYSTEM_USER_CREATE]),
        meta: { title: 'Create System User' },
      },
      {
        name: 'system_user_edit',
        path: 'edit/:systemUserId',
        component: () => import('./views/pages/system-users/EditSystemUser.vue'),
        beforeEnter: UserHasScopes([Roles.SYSTEM_USER_UPDATE]),
        meta: { title: 'Edit System User' },
      },
    ],
  },
  {
    path: '/leaves',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'new_leave',
        path: '/leaves/new',
        component: () => import('./views/pages/calendar/leaves/NewLeave.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_LEAVE_CREATE]),
        meta: { title: 'New Leave Request' },
      },
      {
        name: 'my_leaves',
        path: '/leaves/my',
        component: () => import('./views/pages/calendar/leaves/MyLeaves.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_LEAVE_CREATE]),
        meta: { title: 'My leaves' },
      },
      {
        name: 'all_leaves',
        path: '/leaves/all',
        component: () => import('./views/pages/calendar/leaves/AllLeaves.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_LEAVE_CREATE]),
        meta: { title: 'All leaves' },
      },
      {
        name: 'employees_leaves',
        path: '/leaves/employees',
        component: () => import('./views/pages/calendar/leaves/EmployeesLeaves.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_LEAVE_CREATE]),
        meta: { title: 'Employees leaves' },
      },
      {
        name: 'employee_leaves',
        path: '/leaves/employee/:userId',
        component: () => import('./views/pages/calendar/leaves/ViewEmployeeLeaves.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_LEAVE_CREATE]),
        meta: { title: 'Employee leaves' },
      },
      {
        name: 'archive',
        path: '/leaves/archive',
        component: () => import('./views/pages/calendar/leaves/Archive.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_LEAVE_CREATE]),
        meta: { title: 'Leaves Archive' },
      },
      {
        name: 'approvers',
        path: '/leaves/approvers',
        component: () => import('./views/pages/calendar/leaves/Approvers.vue'),
        beforeEnter: UserHasScopes([Roles.CALENDAR_DEFAULT_APPROVERS]),
        meta: { title: 'Approvers' },
      },
    ],
  },
  {
    path: '/ifm',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'internal_file_manager',
        path: '',
        component: () => import('./views/pages/internal-file-manager/InternalFileManagerTree.vue'),
        meta: { title: 'Internal File Manager' },
      },
    ],
  },
  {
    path: '/',
    component: () => import('./views/dashboard/Index.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'home',
        path: '',
        component: () => import('@/views/dashboard/Dashboard.vue'),
      },
    ],
  },
  {
    path: '/files-manager',
    component: () => import('./views/layouts/Main.vue'),
    children: [
      {
        name: 'ifm_root',
        path: '',
        component: () => import('./views/pages/internal-file-manager/InternalFileManagerTree.vue'),
      },
      {
        name: 'folders',
        path: 'folders',
        component: () => import('./views/pages/internal-file-manager/FoldersManagement.vue'),
      },
    ],
  },
  {
    path: '/mailboxes',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'mailbox_list',
        path: '/',
        component: () => import('./views/pages/mailbox/AllMailboxes.vue'),
        beforeEnter: UserHasScopes([Roles.MAILBOX_MAILBOX_READ]),
        meta: {
          title: 'Mailboxes',
        },
      },
      {
        name: 'mailbox_create',
        path: 'create',
        component: () => import('./views/pages/mailbox/CreateMailbox.vue'),
        beforeEnter: UserHasScopes([Roles.MAILBOX_MAILBOX_CREATE]),
        meta: {
          title: 'Mailbox Create',
        },
      },
    ],
  },
  {
    path: '/ftp-users',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'ftp_user_list',
        path: '/',
        component: () => import('./views/pages/ftp-users/AllFtpUsers.vue'),
        beforeEnter: UserHasScopes([Roles.FTP_USER_FTP_USER_READ]),
        meta: {
          title: 'FTP Users',
        },
      },
      {
        name: 'ftp_user_create',
        path: 'create',
        component: () => import('./views/pages/ftp-users/CreateFtpUser.vue'),
        beforeEnter: UserHasScopes([Roles.FTP_USER_FTP_USER_CREATE]),
        meta: {
          title: 'FTP User Create',
        },
      },
    ],
  },

  // {
  //   path: '/ifm',
  //   name: 'ifm_root',
  //   component: () => import('./views/pages/internal-file-manager/InternalFileManagerTree.vue'),
  //   meta: { title: 'Internal File Manager' },
  //   children: [
  //     {
  //       name: 'folders',
  //       path: 'folders',
  //       component: () => import('@/views/pages/internal-file-manager/FoldersManagement.vue'),
  //       meta: {title: 'Manage Folders'}
  //     },
  //   ]
  // },
  {
    path: '/scrums',
    name: 'Scrums',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'dev_audit',
        path: '/dev-audit/:userId',
        component: () => import('./views/pages/dev-scrums/DevAudit.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_AUDITS_READ]),
        meta: {
          title: 'Scrums',
        },
      },
      {
        name: 'all_audit',
        path: 'audits/all',
        component: () => import('./views/pages/dev-scrums/ViewAllAudits.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_AUDITS_READ]),
        meta: {
          title: 'Scrums',
          description: 'View all audits, export them in excel ',
        },
      },
      {
        name: 'create_audit',
        path: 'create',
        component: () => import('./views/pages/dev-scrums/CreateAudit.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_AUDITS_CREATE]),
        meta: {
          title: 'Create New Audit',
        },
      },
      {
        name: 'dev_scrum_settings',
        path: 'settings',
        component: () => import('./views/pages/dev-scrums/ScrumSettings.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_AUDITS_READ, Roles.SCRUM_SETTINGS_CREATE]),
        meta: {
          title: 'Dev Scrum Settings',
        },
      },
      {
        name: 'dev_scrum_components',
        path: 'components',
        component: () => import('./views/pages/dev-scrums/ViewComponent.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_COMPONENTS_READ]),
        meta: {
          title: 'View Components',
          description: 'View all components',
        },

      },
      {
        name: 'create_component',
        path: 'create/component',
        component: () => import('./views/pages/dev-scrums/CreateComponent.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_COMPONENTS_CREATE]),
        meta: {
          title: 'Create New Audit',
          description: 'Create a new components',
        },
      },
      {
        name: 'component_edit',
        path: 'edit/:componentId',
        component: () => import('./views/pages/dev-scrums/EditComponent.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_COMPONENTS_UPDATE]),
        meta: {
          title: 'Edit Department',
        },
      },
      {
        name: 'audit_edit',
        path: 'edit/audits/:auditId',
        component: () => import('./views/pages/dev-scrums/EditAudit.vue'),
        beforeEnter: UserHasScopes([Roles.SCRUM_AUDITS_UPDATE]),
        meta: {
          title: 'Edit Audit',
        },
      },
    ],
  },
  {
    path: '/internal-tickets',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'bugs_list',
        path: 'bugs',
        component: () => import('./views/pages/internal-tickets/BugList.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Bug List',
        },
      },
      {
        name: 'feature_list',
        path: 'features',
        component: () => import('./views/pages/internal-tickets/FeatureList.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Feature List',
        },
      },
      {
        name: 'archive_list',
        path: 'tickets/completed',
        component: () => import('./views/pages/internal-tickets/Archive.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Archive List',
        },
      },
      {
        name: 'view_internal_ticket',
        path: 'tickets/:ticketId',
        component: () => import('./views/pages/internal-tickets/TicketComponent.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Ticket List',
        },
      },
      {
        name: 'settings_list',
        path: 'settings',
        component: () => import('./views/pages/internal-tickets/SettingsList.vue'),
        beforeEnter: UserHasScopes([Roles.SMS_SMS_READ]),
        meta: {
          title: 'Settings List',
        },
      },
    ],
  },
  {
    path: '/action-logs',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'action_logs',
        path: '/',
        component: () => import('./views/pages/action-logs/AllActionLogs.vue'),
        beforeEnter: UserHasScopes([Roles.ACTION_LOGS_READ]),
        meta: {
          title: 'Action Logs',
        },
      },
    ],
  },
  {
    path: '/backups',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'backup_list',
        path: '/',
        component: () => import('./views/pages/backups/AllBackups.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_BACKUP_READ]),
        meta: {
          title: 'All Backups',
        },
      },
      {
        name: 'backup_details',
        path: ':backupId/details',
        component: () => import('./views/pages/backups/BackupDetails.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_BACKUP_READ]),
        props: true,
      },
      {
        name: 'schedule_list',
        path: 'schedules',
        component: () => import('./views/pages/backups/AllTaskSchedules.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_SCHEDULE_READ]),
        meta: {
          title: 'All Task Schedules',
        },
      },
      {
        name: 'schedule_create',
        path: 'schedules/create',
        component: () => import('./views/pages/backups/CreateTaskSchedule.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_SCHEDULE_CREATE]),
        meta: {
          title: 'Create Schedule',
        },
      },
      {
        name: 'task_create',
        path: 'tasks/create',
        component: () => import('./views/pages/backups/CreateTask.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_TASK_CREATE]),
        meta: {
          title: 'Create Instant Task',
        },
      },
      {
        name: 'task_list',
        path: 'tasks',
        component: () => import('./views/pages/backups/AllTasks.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_TASK_READ]),
        meta: {
          title: 'All Tasks',
        },
      },
      {
        name: 'restore_list',
        path: '/restores',
        component: () => import('./views/pages/backups/AllRestoreTasks.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_LOGS_READ]),
        meta: {
          title: 'All Restore Logs',
        },
      },
      {
        name: 'backup_server_list',
        path: 'servers',
        component: () => import('./views/pages/backups/AllBackupServers.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_SERVER_READ]),
        meta: {
          title: 'All Backup Servers',
        },
      },
      {
        name: 'backup_server_create',
        path: 'create-server',
        component: () => import('./views/pages/backups/CreateBackupServer.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_SERVER_CREATE]),
        meta: {
          title: 'Create Backup Server',
        },
      },
      {
        name: 'backup_repositories',
        path: 'repositories',
        component: () => import('./views/pages/backups/AllBackupRepos.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_REPO_READ]),
        meta: {
          title: 'All Backup Repositories',
        },
      },
      {
        name: 'backup_repository_create',
        path: 'repositories/create',
        component: () => import('./views/pages/backups/CreateBackupRepository.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_REPO_CREATE]),
        meta: {
          title: 'Create Backup Repository',
        },
      },
      {
        name: 'backup_repo_locks',
        path: 'locks',
        component: () => import('./views/pages/backups/ActiveBackupRepoLocks.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_REPO_READ]),
        meta: {
          title: 'Active Locks',
        },
      },
      {
        name: 'backup_create',
        path: 'create',
        component: () => import('./views/pages/backups/CreateBackup.vue'),
        beforeEnter: UserHasScopes([Roles.BACKUP_BACKUP_CREATE, Roles.BACKUP_SCHEDULE_CREATE]),
        meta: {
          title: 'Create Backup',
        },
      },
    ],
  },
  {
    path: '/usage',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      // {
      //   name: 'usage_disk_space',
      //   path: 'disk-space',
      //   component: () => import('./views/pages/usage/DiskSpace.vue'),
      //   beforeEnter: UserHasScopes([Roles.USAGE_DISK_READ]), // pick/create the scope you want
      //   meta: { title: 'Disk Space' },
      // },
      // {
      //   name: 'usage_bandwidth',
      //   path: 'bandwidth',
      //   component: () => import('./views/pages/usage/Bandwidth.vue'),
      //   beforeEnter: UserHasScopes([Roles.USAGE_BANDWIDTH_READ]),
      //   meta: { title: 'Bandwidth' },
      // },
      {
        name: 'usage_list',
        path: '',
        component: () => import('./views/pages/usage/UsageList.vue'),
        beforeEnter: UserHasScopes([Roles.USAGE_READ]),
        meta: { title: 'Usage List' },
      },
      {
        name: 'usage_details',
        path: ':groupId',
        component: () => import('./views/pages/usage/Usage.vue'),
        beforeEnter: UserHasScopes([Roles.USAGE_READ]),
        meta: { title: 'Usage Details' },
      },
    ],
  },
  {
    path: '/website-migrations',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'website_migrations_list',
        path: '',
        component: () => import('./views/pages/website-migrations/WebsiteMigrationsList.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_MIGRATIONS_READ]),
        meta: {
          title: 'Website Migrations List',
        },
      },
      {
        name: 'groups_migrations_list',
        path: 'groups',
        component: () => import('./views/pages/website-migrations/GroupsMigrationsList.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_MIGRATIONS_READ]),
        meta: {
          title: 'Groups Migrations List',
        },
      },
      {
        name: 'group_migrations_list',
        path: 'groups/:id',
        component: () => import('./views/pages/website-migrations/GroupMigrationList.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_MIGRATIONS_READ]),
        meta: {
          title: 'Group Migrations List',
        },
      },
      {
        name: 'databases_migrations_list',
        path: 'databases',
        component: () => import('./views/pages/website-migrations/DatabasesMigrationsList.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_MIGRATIONS_READ]),
        meta: {
          title: 'Databases Migrations List',
        },
      },
      {
        name: 'database_migration_batch',
        path: 'databases/:id',
        component: () => import('./views/pages/website-migrations/DatabaseMigrationBatch.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_MIGRATIONS_READ]),
        meta: {
          title: 'Databases Migrations Batch',
        },
      },
      {
        name: 'view_website_migration',
        path: ':id',
        component: () => import('./views/pages/website-migrations/ViewMigration.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_MIGRATIONS_READ]),
        meta: {
          title: 'View Website Migration',
        },
      },
    ],
  },
  {
    path: '/website-orchestrator',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'resources',
        path: '/',
        component: () => import('./views/pages/website-orchestrator/Resources.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_READ]),
        meta: {
          title: 'Resources',
        },
      },
      {
        name: 'view_resource',
        path: ':websiteId/:resourceType/:resourceId',
        component: () => import('./views/pages/website-orchestrator/ViewResource.vue'),
        beforeEnter: UserHasScopes([Roles.WEBSITE_WEBSITE_READ]),
        meta: {
          title: 'Orchestrator Resource',
        },
      },
    ],
  },
  {
    path: '/plans',
    component: () => import('./views/layouts/Main.vue'),
    beforeEnter: UserIsLoggedIn,
    children: [
      {
        name: 'all_plans',
        path: '/',
        component: () => import('./views/pages/plan/ListPlans.vue'),
        beforeEnter: UserHasScopes([Roles.SYSTEM_USER_PLAN_READ]),
        meta: {
          title: 'All Plans',
        },
      },
    ],
  },
  {
    // Global matcher intended to handle requests to missing pages. Should be placed last, in order to be checked last.
    path: '*',
    component: () => import('@/views/pages/Index.vue'),
    children: [
      {
        name: '404 Error',
        path: '',
        component: () => import('@/views/pages/Error.vue'),
      },
    ],
  },
];

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
